export const LOAD_PROGRAMMES_DATA = 'LOAD_PROGRAMMES_DATA'
export const LOAD_PROGRAMMES_DATA_SUCCESS = 'LOAD_PROGRAMMES_DATA_SUCCESS'
export const SELECTED_PROGRAMME_UPDATE = 'SELECTED_PROGRAMME_UPDATE'

export const LOAD_PROGRAMMES_DATA_BY_ID = 'LOAD_PROGRAMMES_DATA_BY_ID'
export const LOAD_PROGRAMMES_DATA_BY_ID_SUCCESS =
  'LOAD_PROGRAMMES_DATA_BY_ID_SUCCESS'

export const LOAD_TERMS_DATA = 'LOAD_TERMS_DATA'
export const LOAD_TERMS_DATA_SUCCESS = 'LOAD_TERMS_DATA_SUCCESS'
export const SELECTED_TERM_UPDATE = 'SELECTED_TERM_UPDATE'

export const SELECTED_SUB_ACCOUNT_UPDATE = 'SELECTED_SUB_ACCOUNT_UPDATE'

export const LOAD_COURSES_DATA = 'LOAD_COURSES_DATA'
export const LOAD_COURSES_DATA_SUCCESS = 'LOAD_COURSES_DATA_SUCCESS'
export const CLEAR_COURSES_DATA = 'CLEAR_COURSES_DATA'
export const UPDATE_FILTERED_COURSE_DATA = 'UPDATE_FILTERED_COURSE_DATA'

export const LOAD_COURSES_DATA_START = 'LOAD_COURSES_DATA_START'

export const LOAD_ROLES_DATA = 'LOAD_ROLES_DATA'
export const LOAD_ROLES_DATA_SUCCESS = 'LOAD_ROLES_DATA_SUCCESS'

export const LOAD_USER_DATA = 'LOAD_USER_DATA'
export const LOAD_USER_DATA_SUCCESS = 'LOAD_USER_DATA_SUCCESS'

export const SIS_POST_ENROLLMENTS = 'SIS_POST_ENROLLMENTS'
export const SIS_POST_ENROLLMENTS_SUCCESS = 'SIS_POST_ENROLLMENTS_SUCCESS'

export const UPDATE_STEUP_PROGRESS = 'UPDATE_STEUP_PROGRESS'

export const UPDATE_USERE_EMAIL_LIST = 'UPDATE_USERE_EMAIL_LIST'

export const SIS_STATUS = 'SIS_STATUS'
export const SIS_STATUS_SUCCESS = 'SIS_STATUS_SUCCESS'

export const CLEAR_SUMMERY_COURSES = 'CLEAR_SUMMERY_COURSES'

export const ACCESS_TOKEN = 'ACCESS_TOKEN'

export const UPDATE_CSV_ACTION = 'UPDATE_CSV_ACTION'

export const CSV_FIlE_SELECT = 'CSV_FIlE_SELECT'
export const UPLOAD_REQUEST = 'UPLOAD_REQUEST'
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS'
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
export const UPLOAD_FAILURE = 'UPLOAD_FAILURE'

export const LOAD_SECTION_DATA = 'LOAD_SECTION_DATA'
export const LOAD_SECTION_DATA_SUCCESS = 'LOAD_SECTION_DATA_SUCCESS'

export const UPDATE_SECTION_USER_DATA = 'UPDATE_SECTION_USER_DATA'

export const UPDATE_ZOOM_COURSE_TYPE = 'UPDATE_ZOOM_COURSE_TYPE'
export const UPDATE_ZOOM_COURSE_DATA = 'UPDATE_ZOOM_COURSE_DATA'

export const ZOOM_COURSE_UPLOAD_REQUEST = 'ZOOM_COURSE_UPLOAD_REQUEST'
export const ZOOM_COURSE_UPLOAD_SUCCESS = 'ZOOM_COURSE_UPLOAD_SUCCESS'
export const ZOOM_COURSE_UPLOAD_FAILURE = 'ZOOM_COURSE_UPLOAD_FAILURE'

// export const UPDATE_SECTION_USER_DATA = "UPDATE_SECTION_USER_DATA";

export const CREATE_GROUP_CATEGORY = 'CREATE_GROUP_CATEGORY'
export const SUCCESS_GROUP_CATEGORY = 'SUCCESS_GROUP_CATEGORY'

export const LOAD_COURSE_USER_DATA_START = 'LOAD_COURSE_USER_DATA_START'
export const LOAD_COURSE_USER_DATA = 'LOAD_COURSE_USER_DATA'
export const LOAD_COURSE_USER_DATA_SUCCESS = 'LOAD_COURSE_USER_DATA_SUCCESS'
export const UPDATE_SELECTED_COURSE_USER_DETAILS =
  'UPDATE_SELECTED_COURSE_USER_DETAILS'
export const UPDATE_COURSE_STUDENT_EVENT_DATA =
  'UPDATE_COURSE_STUDENT_EVENT_DATA'

export const LOAD_BEST_TEACHING_AWARD_PARAMS = 'LOAD_BEST_TEACHING_AWARD_PARAMS'
export const UPDATE_BEST_TEACHING_AWARD_PARAMS =
  'UPDATE_BEST_TEACHING_AWARD_PARAMS'

export const UPDATE_ZOOM_COURSE_ID = 'UPDATE_ZOOM_COURSE_ID'
export const UPDATE_ZOOM_HOST = 'UPDATE_ZOOM_HOST'
export const LOAD_ZOOM_EVENTS_DATA = 'LOAD_ZOOM_EVENTS_DATA'
export const UPDATE_SELECTED_ZOOM_EVENTS = 'UPDATE_SELECTED_ZOOM_EVENTS'

export const UPDATE_ZOOM_SCHEDULERS = 'UPDATE_ZOOM_SCHEDULERS'
export const UPDATE_ZOOM_COURSE_DETAILS = 'UPDATE_ZOOM_COURSE_DETAILS'

export const APP_LOGIN_EXPIRED = 'APP_LOGIN_EXPIRED'

export const CREATE_USERS_UPDATE_USER_COUNT = 'CREATE_USERS_UPDATE_USER_COUNT'

export const CREATE_USERS_UPDATE_CSV = 'CREATE_USERS_UPDATE_CSV'

export const CREATE_USERS_FORM_DATA = 'CREATE_USERS_FORM_DATA'

export const SAVE_BEST_TEACHING_AWARD_FROM_UPLOAD_REQUEST =
  'SAVE_BEST_TEACHING_AWARD_FROM_UPLOAD_REQUEST'
export const SAVE_BEST_TEACHING_AWARD_FROM_UPLOAD_LOADING =
  'SAVE_BEST_TEACHING_AWARD_FROM_UPLOAD_LOADING'
export const SAVE_BEST_TEACHING_AWARD_FROM_UPLOAD_FAILED =
  'SAVE_BEST_TEACHING_AWARD_FROM_UPLOAD_FAILED'
